import HFlip from './hflip.svg';
import Locked from './locked.svg';
import Rotate from './rotate.svg';
import Unlocked from './unlocked.svg';
import VFlip from './vflip.svg';

export default {
  HFlip,
  Locked,
  Rotate,
  Unlocked,
  VFlip,
};
